import { render, staticRenderFns } from "./CustomerCTEdit.vue?vue&type=template&id=405b9a3b&scoped=true"
import script from "./CustomerCTEdit.vue?vue&type=script&lang=js"
export * from "./CustomerCTEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b9a3b",
  null
  
)

export default component.exports